module.exports = __webpack_public_path__ + "static/parade-2020-house10-c2e2dd5137c7fbea71ca17cd8502f3ec.jpg";